import { FunctionComponent } from 'react'
import { Duration } from '@/components/common/duration-select'
import KolDetailSection, {
  KolDetailSectionProps,
} from '@/components/kol/common/kol-detail-section'
import HashtagAnalyses from '@/components/kol/detail/creative-content-analyses/hashtag-analyses'
import PostList from '@/components/kol/detail/creative-content-analyses/post-list'
import useKolDetailRoute from '@/components/kol/hooks/use-kol-detail-route'
import { useIntl } from '@/i18n/hooks/use-intl'
import type { InfluencerInfo } from '@/types/schema/influencer/influencer-info-schema'
import type { KolInfo } from '@/types/schema/kol/kol-info-schema'
import type { PublicKolInfo } from '@/types/schema/kol/public-kol-info-schema'
import {
  convertPlatformShortcode,
  Platform,
  PlatformShortcode,
} from '@/utils/convert-platform'

interface CreativeContentAnalysesProps {
  anchor: KolDetailSectionProps['header']['anchor']
  duration: Duration.ThreeMonths | Duration.SixMonths
  isFetchingKolInfo: boolean
  isKolInfoLocked: boolean
  kolInfo?: PublicKolInfo | InfluencerInfo | KolInfo
  platform: Platform
  showMockData?: boolean
}

const CreativeContentAnalyses: FunctionComponent<
  CreativeContentAnalysesProps
> = ({
  anchor,
  duration,
  isFetchingKolInfo,
  isKolInfoLocked,
  kolInfo,
  platform,
  showMockData,
}) => {
  const { formatMessage } = useIntl()
  const { searchParams } = useKolDetailRoute()

  const postListPlatform = searchParams.data?.postListPlatform
    ? convertPlatformShortcode(searchParams.data.postListPlatform)
    : platform

  return (
    <KolDetailSection
      header={{
        title: formatMessage({ id: 'kol:nav_creative_content_analyses' }),
        anchor,
      }}
    >
      {[
        PlatformShortcode.Instagram,
        PlatformShortcode.Facebook,
        PlatformShortcode.YouTube,
      ].includes(platform.shortcode) && (
        <HashtagAnalyses
          duration={duration}
          isFetchingKolInfo={isFetchingKolInfo}
          isKolInfoLocked={isKolInfoLocked}
          kolInfo={kolInfo}
          platform={platform}
          showMockData={showMockData}
        />
      )}
      <PostList
        anchorOffset={anchor.offset}
        isFetchingKolInfo={isFetchingKolInfo}
        isKolInfoLocked={isKolInfoLocked}
        kolInfo={kolInfo}
        platform={postListPlatform}
      />
    </KolDetailSection>
  )
}

export default CreativeContentAnalyses
